import React from "react";
import BarekamText from "../../../../../../components/text";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import {Recipient} from "../../../../../../shared/models/user/recipient/recipient";
import {MenuItem} from "@mui/material";

const RecipientFilter = (props: RecipientFilterProps) => {
    const {selectedFilterId, myRecipients, onFilterChange} = props;

    return (
        <BarekamSelect
            variant={'outlined'}
            label={<Message messageKey={'recipient'} sectionId={MessageSections.ORDERS}/>}
            value={selectedFilterId || 'all'}
            type={"filter"}
            fullWidth
            required>
            <MenuItem onClick={() => onFilterChange(undefined)}
                            value={'all'}
                            key={'all'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>
            {

                myRecipients.map(recipient =>
                    <MenuItem onClick={() => onFilterChange(recipient)}
                                    value={recipient.recipientId}
                                    key={recipient.recipientId}>
                        <BarekamText variant={"m"}>
                            {recipient.firstName} {recipient.lastName}
                        </BarekamText>
                    </MenuItem>
                )
            }
        </BarekamSelect>
    );
};

export default RecipientFilter;


interface RecipientFilterProps {
    selectedFilterId: number | undefined;
    myRecipients: Recipient[];
    onFilterChange: (filter: Recipient | undefined) => void
}